import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HelperService } from '../../../core/services/helper.service';
import { I18nService } from '../../../core/services/i18n.service';
import { PaymentPageLinkData } from '../../interfaces/payment-page/payment-page-link-data';
import { PaymentPageLinkInvalidFlags } from '../../interfaces/payment-page/payment-page-link-invalid-flags';
import { SettingsProviderService } from '../../services/settings-provider.service';

@Component({
  template: ''
})
export class BaseAddPaymentPageLinkComponent {

  @Input() paymentPageLinkData: PaymentPageLinkData;
  @Input() paymentPageLinkInvalidFlags: PaymentPageLinkInvalidFlags;
  @Output() dataChanged = new EventEmitter();

  public i18n = inject(I18nService);
  protected messageService = inject(MessageService);
  public settingsProvider = inject(SettingsProviderService);
  public helper = inject(HelperService);
  public today: Date = new Date();
  public dataValid: boolean = false;

}
